import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labPharmacyRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/pharmacies/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/lab/Pharmacies/PharmacyPage/PharmacyPage').then((d) => d.Route));
